import React from 'react';
import PropTypes from 'prop-types';
import CONFIG from 'Config/settings';
import { t } from 'Utils/localization/i18next';
import {
  Select as IkeaDropdown,
  Option as IkeaDropdownItem
} from '@ingka/select';
import './Dropdown.scss';

// IkeaDropdown does not allow using both value and defaultValue props.
// This component should be used only with _value_. For IkeaDropdown with
// defaultValue prop, use Dropdown.

class DropdownControlled extends React.PureComponent {
  render() {
    const id = this.props.formId
      ? `${this.props.formId}-${this.props.name}`
      : this.props.id;
    const hintProp =
      !this.props.removeHintText || this.props.showOptional
        ? { hintText: t('common.dropdown.default') }
        : { hintText: null };

    return (
      <IkeaDropdown
        id={id}
        name={this.props.name}
        {...hintProp}
        label={
          this.props.showOptional
            ? `${t(this.props.label)} ${t('forms.optional')}`
            : t(this.props.label)
        }
        prefix={CONFIG.APP.STYLES_PREFIX}
        className={this.props.className}
        autoComplete={this.props.autoComplete}
        onBlur={this.props.onBlur}
        onChange={this.props.onChange}
        value={this.props.value}
        disabled={this.props.disabled}
        req={this.props.req}
        required={this.props.req}
      >
        {this.props.topOptions.map((option, index) => (
          <IkeaDropdownItem
            {...option}
            key={`${option.value}-${index}`}
            id={`${this.props.formId}-${this.props.name}-${index}`}
            name={t(option.name)}
            style={{ fontWeight: 'bold' }}
          />
        ))}
        {this.props.options.map((option, index) => (
          <IkeaDropdownItem
            {...option}
            key={`${option.value}-${index + this.props.topOptions.length}`}
            id={`${this.props.formId}-${this.props.name}-${index +
              this.props.topOptions.length}`}
            name={t(option.name)}
          />
        ))}
      </IkeaDropdown>
    );
  }
}
DropdownControlled.propTypes = {
  id: PropTypes.string,
  formId: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  showOptional: PropTypes.bool,
  removeHintText: PropTypes.bool,
  // Array of { name: "", value: "" } objects
  options: PropTypes.arrayOf(PropTypes.object),
  topOptions: PropTypes.arrayOf(PropTypes.object),
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  className: PropTypes.string,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  req: PropTypes.bool,
  autoComplete: PropTypes.string
};

DropdownControlled.defaultProps = {
  value: '',
  options: [],
  topOptions: []
};

export default DropdownControlled;
